import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { WEB_ROUTES } from 'src/consts/routes';
import { AuthenticationService } from 'src/app/authentication/authentication.service';
import { HttpCall } from 'src/app/services/httpcall.service';
import { httpVersion, httpRoutes } from 'src/consts/http-routes';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard  {

  constructor(private authService: AuthenticationService, private router: Router, private httpCall: HttpCall) {
  
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    if (this.authService.currentUserValue) {
      this.router.navigate([WEB_ROUTES.LOGIN]);
      return false;
    } else {
      return true;
      // if (this.authService.checkApproverUserSubject.value === true) {
      //   return true;
      // } else {
      //   this.router.navigate(['/authentication/' + WEB_ROUTES.FORCE_FULLY_ADD_APPROVER_USER]);
      //   return false;
      // }

    }
  }
}
